import React, { Fragment, memo } from 'react' ;
import "./ExtractModal.css" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownLong, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Skeleton } from '@mui/material';
import { STATUS } from '../../Constants';
import { CSVLink } from 'react-csv';

const ExtractModal = memo( ({data , status ,closeModal }) => {


  return (
    <div className='extract-data-modal my-font'>
      <div className='extract-head' >
        <h2>Extract Data</h2>
        <div className='btns'>
          <butto className='xclose-btn'>
            <CSVLink data={data} filename='Group Data' style={{width : "100%" , height : "100%"}} >
              <FontAwesomeIcon icon={faDownLong} />
            </CSVLink>
          </butto>
          <button style={{margin : "0px 5px"}} onClick={closeModal} className='xclose-btn'>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        
      </div>

      
 
      <div className='table'>
      
        <div className='row-head'>
          <div className='item'>FBID</div>
          <div className='item'>Phone</div>
          <div className='item'>Name </div>
          <div className='item'>Geneder</div>
          <div className='item'>Work</div>
          <div className='item'>Location</div>
        </div>
        
        <div className='table-body'>
          
          
          {
            status === STATUS.SUCCESS ? 
            data.length > 0 ? 
            data.map((item)=>(
            <div className='row' key={item.FBID}>
              <div className='item'>{item.FBID}</div>
              <div className='item'>{item.Phone}</div>
              <div className='item'>{item.first_name} {item.last_name}</div>
              <div className='item'>{item.gender}</div>
              <div className='item'>{item.work}</div>
              <div className='item'>{item.location}</div>
            </div>
            ))
            :<h4>No Result Found</h4>
            :""
          }


          {
            status === STATUS.LOADDING ? (
              <Fragment>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={15}  /> </div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                </div>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={15}  /> </div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                </div>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={15}  /> </div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                  <div className='item'><Skeleton width={150} height={15}  /></div>
                </div>
              
              </Fragment>

            ) :""
          }


        </div>

      </div>

    </div>
  )
})

export default ExtractModal
